// Patch navigator.mediaDevices.getUserMedia to route through getUserMediaSafe
// Importing this module early will apply the patch app-wide.

import { getUserMediaSafe } from './getUserMediaSafe';

(function applyPatch() {
  if (typeof window === 'undefined') return;
  if (!navigator?.mediaDevices?.getUserMedia) return;
  if (window.__gUMPatched) return;

  try {
    const original = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    Object.defineProperty(navigator.mediaDevices, '__originalGetUserMedia', {
      value: original,
      enumerable: false,
      configurable: false,
      writable: false
    });

    navigator.mediaDevices.getUserMedia = async function patchedGetUserMedia(constraints = { audio: true, video: true }) {
      const { stream } = await getUserMediaSafe(constraints);
      return stream;
    };

    window.__gUMPatched = true;
  } catch {
    // no-op
  }
})();